export default __webpack_public_path__ + "static/banachiewicz-35e31c94db86f26e94de73332297d73a.jpg";